import React, { useEffect, useState } from 'react'
import {apiAuth} from 'api-methods'
import { delToLocalStorage, saveToLocalStorage } from 'helper-func'
import {Link, useNavigate} from "react-router-dom";
import '../css/LoginPage.css'
import { AUTH_ERROR_STORAGE_KEY, isSuccessStatus } from '../utils/authError'

const LoginPage = () => {
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const getAuthErrorMessage = (payload) => {
        if (payload === null || payload === undefined) return 'Неизвестная ошибка'
        if (typeof payload === 'string') return payload
        if (typeof payload === 'object') {
            return payload.message || payload.error || payload.detail || JSON.stringify(payload)
        }
        return String(payload)
    }

    useEffect(() => {
        const authErrorCode = localStorage.getItem(AUTH_ERROR_STORAGE_KEY)
        if (!authErrorCode) return

        localStorage.removeItem(AUTH_ERROR_STORAGE_KEY)
        if (authErrorCode === 'SESSION_EXPIRED') {
            setError('Сессия истекла. Войдите снова')
        } else if (authErrorCode === 'ACCESS_DENIED') {
            setError('Недостаточно прав для выполнения операции')
        } else if (authErrorCode === 'SERVER_UNAVAILABLE') {
            setError('Сервер временно недоступен. Пожалуйста, попробуйте позже')
        }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const login = formData.get('login')
        const password = formData.get('password')
        if (!login || !password) { setError('Заполните все поля'); return }

        setLoading(true)
        setError('')
        await apiAuth({ "login": login, "password": password })
            .then(data => {
                if (isSuccessStatus(data.code)) {
                    let authData = { "dataNow": Date.now(), "authData": data.data }
                    if (saveToLocalStorage('authData', authData)) { navigate('/backoffice/subscriptions') } else { setError('Ошибка авторизации') }
                } else if (([500, 502, 504]).indexOf(data.code) > -1) {
                    setError('Сервер временно недоступен. Пожалуйста, попробуйте позже')
                } else {
                    setError('Ошибка авторизации - ' + getAuthErrorMessage(data.data))
                    delToLocalStorage('authData')
                }
            })
            .catch(_ => {
                setError('Сервер временно недоступен. Пожалуйста, попробуйте позже')
            })
            .finally(_ => { setLoading(false) })
    }

    return (
        <div className="LoginPage">
            <div className="LoginPage__left-panel">
                <div className="LoginPage__left-content">
                    <div className="LoginPage__left-logo"></div>
                    <h1 className="LoginPage__left-title">Добро пожаловать</h1>
                    <p className="LoginPage__left-subtitle">Чтобы управлять своими подписками, вам необходимо войти в систему </p>
                </div>
            </div>

            <div className="LoginPage__form-container">
                <form className="LoginPage__form" onSubmit={handleSubmit}>
                    <div className="LoginPage__form-header">
                        <div className="LoginPage__mobile-logo"></div>
                        <h2 className="LoginPage__title">Вход в систему</h2>
                    </div>

                    <div className="LoginPage__form-group">
                        <label className="LoginPage__label" htmlFor="login">Логин</label>
                        <input className="LoginPage__input" type="text" id="login" name="login" placeholder="Введите логин" autoComplete="username" disabled={loading} />
                    </div>

                    <div className="LoginPage__form-group">
                        <label className="LoginPage__label" htmlFor="password">Пароль</label>
                        <input className="LoginPage__input LoginPage__input--password" type="password" id="password" name="password" placeholder="Введите пароль" autoComplete="current-password" disabled={loading} />
                    </div>

                    {error && (<div className="LoginPage__error LoginPage__error--visible">{error}</div>)}

                    <button type="submit" className={`allPagesStyleButton underlined ${loading ? 'LoginPage__button--loading' : ''}`} disabled={loading}>
                        {loading ? 'Вход...' : 'Войти'}
                    </button>

                    <div className="LoginPage__forgot-password">
                        <Link to="/panel/recoverypassword" className="LoginPage__forgot-button">
                            Не помню пароль
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default LoginPage
